import { IAppsFlyerSDK } from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const appsFlyerSDK: IAppsFlyerSDK = __WEB__ ? require('./web').default : require('./native').default;

export default appsFlyerSDK;
export * from './types';
export * from './constants';
export * from './deepLinkUtils';
